<template>
  <div class="table-header">
    <el-button icon="el-icon-arrow-left" circle size="mini" @click="onYearChange(year - 1)"></el-button>
    <span class="title">{{ fullTitle }}</span>
    <el-button icon="el-icon-arrow-right" circle size="mini" @click="onYearChange(year + 1)"></el-button>
  </div>
</template>

<script>
import { Vue, Component, Model, Prop } from 'vue-property-decorator';

@Component
export default class YearToggle extends Vue {
  @Model('change', { type: Number, required: true }) year;
  @Prop({ type: String, required: true }) title;

  get fullTitle() {
    return `${this.year}年度${this.title}`;
  }

  onYearChange(year) {
    this.$emit('change', year);
  }
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $primary;
  color: #fff;
  padding: 5px 10px;

  .title {
    margin: 0 10px;
  }
}
</style>
